import React, { useState, useEffect } from 'react';

const AdvertisementPopup = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show popup after a delay (e.g., 3 seconds)
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 10000);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => setIsVisible(false);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-gradient-to-br from-blue-500 to-purple-600 text-white rounded-lg shadow-2xl p-8 w-11/12 max-w-lg transform transition-transform duration-500 scale-100 hover:scale-105">
        <h2 className="text-2xl font-extrabold mb-4 text-center">
          🎉 Special Offer!
        </h2>
        <p className="text-sm mb-6 text-center leading-relaxed">
          Unlock <span className="font-bold">20% off</span> all services - Limited time only!
        </p>

        <div className="flex justify-center space-x-4 mt-6">
          <button
            onClick={handleClose}
            className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-6 py-2 rounded-lg text-sm font-semibold transition"
          >
            Close
          </button>
          <a
            href="/register"
            className="bg-yellow-400 hover:bg-yellow-500 text-gray-900 px-6 py-2 rounded-lg text-sm font-semibold transition"
          >
            Get Offer
          </a>
        </div>
      </div>
    </div>
  );
};

export default AdvertisementPopup;